(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-sidebar-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-cf-category-search]')) return;
  const root = event.target.closest('[data-cf-side-menu]');
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const query = normalize(event.target.value.trim());
  const details = [...root.querySelectorAll('details')];
  if (query && !root.dataset.filtering) {
    details.forEach(node => node.dataset.wasOpen = String(node.open));
    root.dataset.filtering = 'true';
  }
  root.querySelectorAll('[data-cf-menu-item]').forEach(item => {
    item.hidden = query !== '' && !normalize(item.textContent).includes(query);
  });
  if (query) details.forEach(node => { node.open = !node.closest('[data-cf-menu-item]').hidden; });
  else if (root.dataset.filtering) {
    details.forEach(node => { node.open = node.dataset.wasOpen === 'true'; delete node.dataset.wasOpen; });
    delete root.dataset.filtering;
  }
  const visible = [...root.querySelectorAll('[data-cf-menu-item]')].some(item => !item.hidden);
  root.querySelector('[data-cf-menu-empty]').hidden = visible;
});
document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-cf-open-categories]');
  if (openButton) {
    const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
    if (dialog && !dialog.open) { dialog.showModal(); openButton.setAttribute('aria-expanded', 'true'); }
  }
  const closeButton = event.target.closest('[data-cf-close-categories]');
  if (closeButton) closeButton.closest('dialog').close();
  if (event.target.matches('.cf-category-drawer')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX > rect.right || event.clientY > rect.bottom) event.target.close();
  }
});
document.addEventListener('close', (event) => {
  if (!event.target.matches('.cf-category-drawer')) return;
  document.querySelectorAll('[data-cf-open-categories]').forEach(button => {
    if (button.getAttribute('aria-controls') === event.target.id) button.setAttribute('aria-expanded', 'false');
  });
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-whatsapp-chat')) {
  customElements.define('cf-whatsapp-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const close = () => { details.open = false; this.querySelector('summary').focus(); };
      this.querySelector('[data-close]').addEventListener('click', close);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape' && details.open) close(); });
      const field = this.querySelector('textarea');
      field.addEventListener('input', () => field.setCustomValidity(''));
      this.querySelector('form').addEventListener('submit', (event) => {
        if (!field.value.trim()) {
          event.preventDefault();
          field.value = '';
          field.reportValidity();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
